export const TRIAGE_PRIORITIES = {
  low: 'baja',
  medium: 'media',
  high: 'alta',
};

export const triagePriorityLabels = {
  baja: 'Baja',
  media: 'Media',
  alta: 'Alta',
};

export const alarmSignOptions = [
  ['chestPain', 'Dolor de pecho'],
  ['severeBreathingDifficulty', 'Dificultad respiratoria severa'],
  ['fainting', 'Desmayo o perdida de conciencia'],
  ['neurologicalDeficit', 'Debilidad, confusion o alteracion neurologica'],
  ['severeBleeding', 'Sangrado importante'],
  ['persistentHighFever', 'Fiebre alta persistente'],
  ['severePain', 'Dolor intenso o progresivo'],
  ['pregnancyRisk', 'Embarazo con dolor, sangrado o signos de alarma'],
];

const highRiskKeywords = [
  'dolor pecho',
  'pecho',
  'respirar',
  'ahogo',
  'falta de aire',
  'desmayo',
  'convulsion',
  'sangrado',
  'paralisis',
  'confusion',
  'embarazo',
];

const mediumRiskKeywords = [
  'fiebre',
  'vomito',
  'diarrea',
  'dolor',
  'infeccion',
  'tos',
  'asma',
  'diabetes',
  'hipertension',
];

export const emptyPreTriageForm = {
  mainSymptoms: '',
  evolutionTime: '',
  alarmSigns: {},
  relevantHistory: '',
};

export const normalizeTriagePriority = (priority = TRIAGE_PRIORITIES.low) => (
  triagePriorityLabels[priority] ? priority : TRIAGE_PRIORITIES.low
);

export const getTriagePriorityLabel = (priority) => (
  triagePriorityLabels[normalizeTriagePriority(priority)] || triagePriorityLabels.baja
);

export const classifyPreTriage = ({ mainSymptoms = '', evolutionTime = '', alarmSigns = {}, relevantHistory = '' } = {}) => {
  const selectedAlarmSigns = Object.values(alarmSigns || {}).filter(Boolean).length;
  const text = `${mainSymptoms} ${evolutionTime} ${relevantHistory}`.toLowerCase();
  const hasHighRiskText = highRiskKeywords.some((keyword) => text.includes(keyword));
  const hasMediumRiskText = mediumRiskKeywords.some((keyword) => text.includes(keyword));
  const hasLongEvolution = /(semana|semanas|mes|meses|[7-9]\s*dias|1[0-9]\s*dias|2[0-9]\s*dias|3[0-1]\s*dias)/.test(text);

  if (selectedAlarmSigns > 0 || hasHighRiskText) return TRIAGE_PRIORITIES.high;
  if (hasMediumRiskText || hasLongEvolution) return TRIAGE_PRIORITIES.medium;
  return TRIAGE_PRIORITIES.low;
};

export const buildPreTriageSummary = (preTriage) => {
  if (!preTriage) return 'Pretriaje pendiente';
  const priority = getTriagePriorityLabel(preTriage.priority);
  const symptoms = preTriage.mainSymptoms || 'Sintomas no registrados';
  const evolution = preTriage.evolutionTime || 'Tiempo no registrado';
  return `${priority} · ${symptoms} · ${evolution}`;
};
